import { useState } from 'react'
import { Icon } from 'packages/eid-icons'
import { Button, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useTranslation } from 'react-i18next'

const useGreenStyles = makeStyles((theme)=>
    createStyles({
        root: (styles) => ({
            position: 'relative',
            height: '31px',
            padding: '8px 12px',
            borderRadius: '4px',
            width: 'max-content',
            boxShadow: '0 0 0 0',
            textTransform: 'capitalize',

            backgroundColor: 'transparent',
            border: `solid 1px ${theme?.palette?.primary?.main}`,

            color: theme?.palette?.primary?.main,
            '&:hover': {
                backgroundColor: theme?.palette?.primary?.main,
                color: 'white',
                cursor: 'hand',
            },
            ...styles,
        }),
        disabled: {
            backgroundColor: '#efeff1 !important',
            color: '#8b909a !important',
            border: 'solid 1px #8b909a !important',
        },
    }),
)

const EditButton = ({ onClick, disabled, showEndIcon = true, styles }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [actionsButtonIconColor, setActionsButtonIconColor] =
        useState(theme?.palette?.primary?.main)

    const buttonClasses = useGreenStyles(styles)

    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            onMouseEnter={() => {
                setActionsButtonIconColor('white')
            }}
            onMouseLeave={() => {
                setActionsButtonIconColor(theme?.palette?.primary?.main)
            }}
            classes={buttonClasses}
            endIcon={
                showEndIcon && (
                    <Icon
                        name="DeleteX"
                        style={{ width: '6px', height: '6px' }}
                        color={disabled ? '#8b909a' : actionsButtonIconColor}
                        fill={disabled ? '#8b909a' : actionsButtonIconColor}
                    />
                )
            }
        >
            {t('Edit')}
        </Button>
    )
}

export default EditButton
